import { isPlainObject } from 'lodash'

const LOCKS = ['duration', 'date']

export function transformIfLocked(props) {
  const { locked, system_only, field } = props

  if (!locked && !system_only) return props
  if (LOCKS.includes(field.type)) return props

  const newProps = {
    ...props,
    field: { ...field, type: 'static' },
  }

  return newProps
}

export function toOptions(hash, isSkipNa) {
  if (isPlainObject(hash)) {
    if (isSkipNa) return Object.entries(hash)
    return Object.entries(hash).concat([['n/a', 'n/a']])
  }

  if (Array.isArray(hash)) {
    if (isSkipNa) return hash.map((item) => [item, item])
    return hash.map((item) => [item, item]).concat([['n/a', 'n/a']])
  }

  return []
}
